import { ErrorBoundary as SentryErrorBoundary } from '@sentry/react'

const ErrorBoundary = (props) => {
    return (
        <SentryErrorBoundary
            fallback={
                <h1>
                    Whoops, we didn't expect this. Try refreshing this page!
                </h1>
            }
        >
            {props.children}
        </SentryErrorBoundary>
    )
}

export default ErrorBoundary
